// removed by extract-text-webpack-plugin
module.exports = {"base":"LTJpW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannerSelect/BannerSelect.scss
// module id = 1791
// module chunks = 0